<template>
    <section class="page-section">
                <div class="updataPsw">
                    修改密码
                </div>
                <el-form size="small" ref="pwdDialogData" :model="pwdDialogData" label-width="130px" class="content-form" :rules="rules" style="margin-bottom: 20px;">
                    <el-form-item label="原密码" prop="oldPassword">
                        <el-input v-model="pwdDialogData.oldPassword" class="w300" placeholder="请输入原密码" autocomplete="new-password" @blur="blurEvent"></el-input>
                    </el-form-item>
                    <p class="tips" v-if="pwdTips">*原密码错误</p>
                    <el-form-item label="新密码" prop="newPassword">
                        <el-input type="password" v-model="pwdDialogData.newPassword" class="w300" placeholder="请输入新密码" autocomplete="new-password"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="againPassword">
                        <el-input type="password" v-model="pwdDialogData.againPassword" class="w300" placeholder="请再次输入新密码" autocomplete="new-password"></el-input>
                    </el-form-item>
                </el-form>

                <span slot="footer" class="dialog-footer">
                    <el-button size="small" type="primary" @click="changePassword('pwdDialogData')" :loading="pwdDialogShowLoading">确 定</el-button>
                    <el-button size="small" plain @click="pwdCancle">取 消</el-button>
                </span>
            </section>
</template>

<script>
import { updatePsd, checkOldPassword } from '@/common/api';
export default {
    name: 'dashboard',
    data() {
        var validatePass = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('*请输入新密码'));
                } else if (value.toString().length < 6) {
                    callback(new Error('*密码长度不得小于6位'))
                } else {
                    callback();
                }
            };
                var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('*请再次输入密码'));
                } else if (value.toString().length < 6) {
                    callback(new Error('*密码长度不得小于6位'))
                } else if (value !== this.pwdDialogData.newPassword) {
                    callback(new Error('*两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
        return {
            pwdDialogShowLoading: false, // 修改密码弹窗确定按钮loading
            crmUserMobile: localStorage.getItem('crmUserMobile'), // 获取用户手机号
            pwdDialogData: { // 修改密码弹窗表单
                oldPassword: '', // 原密码
                newPassword: '', // 新密码
                againPassword: '' // 重复新密码
            },
            rules: { // 修改密码弹窗表单正则
                oldPassword: [
                { required: true, message: "*请输入原密码", trigger: "blur" }
                ],
                newPassword: [
                { required: true, validator: validatePass, trigger: "blur" }
                ],
                againPassword: [
                { required: true, validator: validatePass2, trigger: "blur" }
                ]
            },
            pwdTips: false
        }
    },
    methods: {
        blurEvent(){
            var params ={
                oldPsd: this.pwdDialogData.oldPassword
            }

            if(this.pwdDialogData.oldPassword){
                checkOldPassword(params).then(res => {
                    if(res.code == 0){
                        this.pwdTips = false;
                    }else{
                        this.pwdTips = true;
                        setTimeout(function(){ 
                            this.pwdTips = false;
                        }, 3000);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                })
            }
        },
        pwdCancle(){
            location.reload();
        },
        /**
         * [changePassword description] 更改密码
         * @param  {[type]} pwdDialogData [description] 更改密码表单数据
         * @return {[type]}               [description]
         */ 
        changePassword(pwdDialogData){
            this.$refs[pwdDialogData].validate(valid => {
                if (valid) {
                    this.pwdDialogShowLoading = true;
                    var params = {
                        oldPsd: this.pwdDialogData.oldPassword,
                        newPsd: this.pwdDialogData.newPassword,
                        confirmNewPsd: this.pwdDialogData.againPassword
                    };
                    updatePsd(params).then(res => {
                        this.pwdDialogShowLoading = false;
                        if(res.code == 0){
                            this.pwdDialogShow = false;
                            this.$message({ message: '修改密码成功', type: "success" });
                            this.$refs[pwdDialogData].resetFields();
                            this.$router.push({ path: '/login' });

                        }else{
                            this.pwdDialogShow = false;
                            this.$message({ message: res.msg, type: "error" });
                            this.$refs[pwdDialogData].resetFields();
                        }
                    }).catch(error => {
                        this.pwdDialogShowLoading = false;
                        this.$message.error('服务器异常');
                    })
                } else {
                    return false;
                }
            });
        }
    },
    mounted() {

    }
}
</script>

<style lang="scss" scoped>
    @import "../../../common/styles/base/mixin-font";
    @import "../../../common/styles/base/mixin-common";

    ::v-deep .updataPsw{
        margin: 0px;
        padding: 0px 0px 0px 10px;
        height: 36px;
        line-height: 36px;
        color: $textColor;
        font-size: $baseFS;
        background: $colorPageBg;
        margin-bottom: 25px;
    }
    ::v-deep .dialog-footer{
        padding-left: 130px;
    }
    .app-container .page-main .page-section{
        height: 550px;
    }
    p.tips{
        color: $warningColor;
        padding-top: 2px;
        font-size: $smallFS;
        position: relative;
        left: 130px;
        top: -20px;
    }
    .content-form{
        padding-bottom: 0px;
    }
</style>